import { render, staticRenderFns } from "./courseSearch.html?vue&type=template&id=99bdfd20&scoped=true&"
import script from "./courseSearch.js?vue&type=script&lang=js&"
export * from "./courseSearch.js?vue&type=script&lang=js&"
import style0 from "./courseSearch.css?vue&type=style&index=0&id=99bdfd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bdfd20",
  null
  
)

export default component.exports